import { render, staticRenderFns } from "./TabClientDetails.vue?vue&type=template&id=74c6469e&scoped=true"
import script from "./TabClientDetails.vue?vue&type=script&lang=js"
export * from "./TabClientDetails.vue?vue&type=script&lang=js"
import style0 from "./TabClientDetails.vue?vue&type=style&index=0&id=74c6469e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c6469e",
  null
  
)

export default component.exports